import { gql } from 'urql'

export const FragWatchNowSection = gql`
  fragment WatchNowSection on WatchNowSection {
    id
    title
    subtitle
    navigationAction {
      url
      label
    }
  }
`
